export default function toggle_absence() {
  $(".toggle-comment").on("click", function(){
    var data_id = $(this).attr("data-id");
    $(".col-12.ccrt-item[data-id='" + data_id +"']").toggleClass('d-none');
  });
}
